import { ReactNode } from "react"

interface Props {
  children: ReactNode
  onClick?: () => void
  type?: "button" | "submit" | "reset" | undefined
  className?: string
}

function ButtonSecondary({children, onClick, type, className}: Props) {
  return (
    <button 
      className={`focus:outline-none focus:ring-4 focus:ring-gray-400 text-white bg-gray-500 hover:ring-4 hover:ring-gray-400 py-1 px-4 rounded ${className || ''}`}
      type={type}
      onClick={onClick}
    >{children}</button>
  )
}

export default ButtonSecondary